import { API_KEY } from "./Constants/Constants"
export const orginals=`discover/tv?api_key=${API_KEY}&with_networks=213`
export const action= `discover/movie?api_key=${API_KEY}&with_genres=28`
export const comedy=`discover/movie?api_key=${API_KEY}&with_genres=35`